"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEvidence = void 0;
const react_1 = require("react");
const lib_1 = require("use-debounce/lib");
const crud_source_hook_1 = require("../../utils/crud-source-hook");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const empty_component_1 = require("../../utils/empty-component");
const scrollable_source_hook_1 = require("../../utils/scrollable-source-hook");
const evidence_types_1 = require("./evidence-types");
const navigation_context_1 = require("../navigation/navigation-context");
const item_redirect_hook_1 = require("./hook/item-redirect-hook");
function useEvidence({ tableProps, detailProps, apiProps, }) {
    var _a, _b;
    item_redirect_hook_1.useEvidenceItemRedirect();
    const tableSource = scrollable_source_hook_1.useScrollableSource({
        url: apiProps.url + '/list',
        listItems: apiProps.listItems,
    });
    const crudSource = crud_source_hook_1.useCrudSource({
        url: apiProps.url,
        getItem: apiProps.getItem,
        createItem: apiProps.createItem,
        updateItem: apiProps.updateItem,
        deleteItem: apiProps.deleteItem,
    });
    const tableRef = react_1.useRef(null);
    const detailRef = react_1.useRef(null);
    const splitScreenRef = react_1.useRef(null);
    const { stateAction } = react_1.useContext(navigation_context_1.NavigationContext);
    react_1.useEffect(() => {
        if ((stateAction === null || stateAction === void 0 ? void 0 : stateAction.action) === evidence_types_1.EvidenceStateAction.NEW_ITEM) {
            // needs to do in next frame after Detail component is rendered
            requestAnimationFrame(() => {
                var _a;
                (_a = detailRef.current) === null || _a === void 0 ? void 0 : _a.startNew(stateAction.data);
            });
        }
        if ((stateAction === null || stateAction === void 0 ? void 0 : stateAction.action) === evidence_types_1.EvidenceStateAction.SHOW_ITEM) {
            requestAnimationFrame(() => {
                var _a;
                (_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.setActiveRow(stateAction.data);
            });
        }
    }, [stateAction]);
    const handleActiveRowChange = event_callback_hook_1.useEventCallback((id) => {
        var _a, _b, _c, _d, _e, _f;
        (_a = detailRef.current) === null || _a === void 0 ? void 0 : _a.setActive(id);
        (_c = (_b = detailRef.current) === null || _b === void 0 ? void 0 : _b.formRef) === null || _c === void 0 ? void 0 : _c.resetValidation();
        const isFullscreenTable = (_d = splitScreenRef.current) === null || _d === void 0 ? void 0 : _d.isLeftOnFullscreen();
        if (isFullscreenTable) {
            (_e = splitScreenRef.current) === null || _e === void 0 ? void 0 : _e.handleMoveToMiddle();
        }
        (_f = tableProps === null || tableProps === void 0 ? void 0 : tableProps.onActiveChange) === null || _f === void 0 ? void 0 : _f.call(tableProps, id);
    });
    const [handleActiveRowChangeDebounced] = lib_1.useDebouncedCallback(handleActiveRowChange, 500);
    const handleDetailPersisted = event_callback_hook_1.useEventCallback((id) => {
        var _a, _b;
        (_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.refresh();
        (_b = tableRef.current) === null || _b === void 0 ? void 0 : _b.setActiveRow(id);
    });
    const columns = (_a = tableProps === null || tableProps === void 0 ? void 0 : tableProps.columns) !== null && _a !== void 0 ? _a : [];
    const FieldsComponent = (_b = detailProps === null || detailProps === void 0 ? void 0 : detailProps.FieldsComponent) !== null && _b !== void 0 ? _b : empty_component_1.EmptyComponent;
    return {
        columns,
        FieldsComponent,
        tableSource,
        crudSource,
        tableRef,
        splitScreenRef,
        detailRef,
        handleActiveRowChange: handleActiveRowChangeDebounced,
        handleDetailPersisted,
    };
}
exports.useEvidence = useEvidence;
//# sourceMappingURL=evidence-hook.js.map